import Helper from '../../Helpers/Helper.js';
import NormalType from './NormalType.js';

export default class ArrayType extends NormalType {
  items;
  minItems;

  constructor(numberOfMinItems) {
    super(Helper.ARRAY);
    this.items = {};
    this.minItems = numberOfMinItems;
  }

  setItemsObject(obj) {
    this.items = obj;
  }

  getItemsObj() {
    return this.items;
  }
}
